import React, { Suspense } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import AccountsPage from "../management/Accounts";
import { LayoutSplashScreen } from "../../../_metronic";

export default function HomePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /accounts. */
          <Redirect exact from="/" to="/accounts" />
        }
        <Route path="/accounts/:customerId?" component={AccountsPage} />
        <Redirect to="/error/error-v1" />
      </Switch>
    </Suspense>
  );
}
